import React from 'react'
import TechBackground from '../../../../assets/images/TechBackground.png'
import techimg from '../../../../assets/images/tech1.png'
import './technicaldesing.css'
import { useTranslation } from 'react-i18next';


function TechnicalDesing() {
  const {t} = useTranslation();
  return (
    <div className='technical-main'>
        <div className='technical-bacground' style={{ backgroundImage: `url(${TechBackground})` }}>
                <div className='tech-textimg'>
                      <p> {t('At Ce Enologica, we specialize in transforming your vision into a meticulously planned wine factory. To begin crafting your ideal wine production facility, please provide us with key details about the type of factory you envision, its desired size, and any specific requirements you might have.')}</p>
                      <div className='marani'>
                      <img src={techimg}/>
                    
                      <p>   {t('Our leading Italian architects will then create a comprehensive plan for your factory, incorporating every detail to ensure it meets your exact specifications. Partner with Ce Enologica to bring your wine factory project to life with precision and elegance.')}</p>
                      </div>
                </div>

        </div>


    </div>
  )
  
}

export default TechnicalDesing;